import React from 'react';
import DishesList from './DishesList';

function BeveragesList({ restaurantId }) {
  return <DishesList restaurantId={restaurantId} dishType="beverage" />;
}

export default BeveragesList;
